module.exports = __webpack_public_path__ + "img/jbt9162_23_1999.prt.a3365f5d.jpg";